/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../base.component';
import { Component, Input } from '@angular/core';
import { MenuConfigModel, MenuItemsModel } from '../../../models';
import { MenuService, ModalService } from '../../../services';

@Component({
    selector: 'app-burger-menu-3',
    templateUrl: './burger-menu3.0.component.html',
    styleUrls: ['./burger-menu3.0.component.scss']
})
export class BurgerMenu30Component extends BaseComponent {
    /**
     * Menu object
     */
    @Input() public menuConfig: MenuConfigModel = <MenuConfigModel>{};

    /**
     * Enable user or another component to force the level menu open.
     */
    @Input() public forceLevelMenuOpen: boolean = false;

    /**
     * Store the menu state.
     */
    public isOpen: boolean = false;

    /**
     * Set active menu item
     */
    public activeMenuItem: string = '';

    /**
     * Show the primary menu children.
     */
    public showPrimaryMenuChildren: string = '';

    /**
     * Show the secondary menu children.
     */
    public showSecondaryMenuChildren: string = '';

    constructor(
        private activatedRoute: ActivatedRoute,
        private menuService: MenuService,
        private modalService: ModalService,
        private router: Router
    ) {
        super();
    }

    /**
     * Toggle menu state.
     */
    public toggleMenu(): void {
        this.isOpen = !this.isOpen;
        this.menuService.menuOpen.next(this.isOpen);
    }

    /**
     * Toggle the menu chevron.
     * @param menuItem
     */
    public toggleChevron(menuItem: MenuItemsModel): 'chevron-right' | 'chevron-down' | 'none' {
        if (!menuItem.children?.length) {
            return;
        }

        if (menuItem.children?.length) {
            return this.showPrimaryMenuChildren === menuItem.id || this.showSecondaryMenuChildren === menuItem.id
                ? 'chevron-down' : 'chevron-right';
        }
    }

    /**
     * Toggle group and navigate
     * @param menuItem
     */
    public toggleNav(menuItem: any): void {
        if (menuItem.disabled || menuItem.comingSoon) {
            return;
        }

        if (menuItem.externalLink) {
            window.open(menuItem.location, '_blank');
            this.isOpen = false;

            return;
        }

        // Toggle level 3 parent and children.
        if (menuItem.isChild && menuItem.children?.length) {
            this.showSecondaryMenuChildren = menuItem.id !== this.showSecondaryMenuChildren ? menuItem.id : null;

            return;
        }

        if (menuItem.children?.length) {
            this.showPrimaryMenuChildren = menuItem.id !== this.showPrimaryMenuChildren ? menuItem.id : null;

            return;
        }

        if (menuItem.location) {
            this.activeMenuItem = menuItem.id;
            this.router.navigate([menuItem.location], { relativeTo: this.activatedRoute })
                .then((): void => {
                    this.toggleMenu();
                }).catch();
        }
    }

    /**
     * Logout helper function to open modal and close burger menu.
     */
    public openLogoutModal(): void {
        this.toggleMenu();
        this.modalService.openModalInParent('logoutConfirm');
    }
}
